module.exports = __webpack_public_path__ + "static/media/avril-lavigne.14d31bf5.jpg";